<template>
    <div>
        <div class="banner">
            <div class="swiper-wrapper">
        <div class="swiper-slide"><img src="@/assets/goyb02.png" alt="" /></div>
        <div class="swiper-slide"><img src="@/assets/goyb03.png" alt="" /></div>
        <div class="swiper-slide"><img src="@/assets/goyb01.png" alt="" /></div>
      </div>
      <!-- 如果需要分页器 -->
      <!-- <div class="swiper-pagination"></div> -->

      <!-- 如果需要导航按钮 -->
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
        </div>
        <!-- 标题 -->
        <div class="title">
            团队简介
        </div>
        <!-- <hr class="title-hr"> -->
        <div class="main">
            <div class="main_boss">
            <div class="boss-content">
                <div class="a">兼任公司菜品研发中心负责人</div>
                <div class="a">高级餐饮职业经理人</div>
                <div class="a">食品安全管理师</div>
                <div class="a">健康管理师</div>
                <div class="a">30余年餐饮行业从业经验</div>
            </div>
            <div class="boss-title">
                <div class="boss-work">翼博餐饮总经理</div>
                <div class="boss-name">杨天义</div>
            </div>
            <div class="boss">
                <img src="../../assets/tdjj/01.png" alt="">
            </div>
        </div>
        <div class="main_boss2">
            <div class="boss-title2">
                <div class="boss-work">翼博餐饮副总经理</div>
                <div class="boss-name">杨天龙</div>
            </div>
            <div class="boss2">
                <img src="../../assets/tdjj/02.png" alt="">
            </div>
             <div class="boss-content2">
                <div class="b">兼任公司运营中心负责人、产品研发中心负责人</div>
                <div class="b">食品安全总监</div>
                <div class="b">高级餐饮职业经理人</div>
                <div class="b">高级物流师</div>
                <div class="b">世界五百强企业20余年供应链管理经验</div>
                <div class="b">曾任德邦物流、京东物流河南省区运营机构负责人</div>
            </div>
        </div>
        </div>
        <div class="title1">菜品研发中心</div>
        <div class="caipin">
            <div class="caipin-box">
                <div class="caipin-img">
                    <img src="../../assets/tdjj/09.png" alt="">
                </div>
                <div class="caipin-title">
                    <div class="caipin-work">菜品研发中心总监</div>
                    <div class="caipin-name">吴付徳</div>
                </div>
                <div class="caipin-content">
                    <div class="c">高级公共营养师</div>
                    <div class="c">河南豫菜大师</div>
                    <div class="c">国家一级厨师</div>
                    <div class="c">中国青年御膳大师</div>
                    <div class="c">中国饭店协会名厨委员会委员</div>
                    <div class="c">第四届百鱼宴特金奖</div>
                    <div class="c">第二界“豫菜杯”竞赛特金奖</div>
                    <div class="c">河南省酒店餐饮业技术创新标兵</div>
                </div>
            </div>
            <div class="caipin-box">
                <div class="caipin-img">
                    <img src="../../assets/tdjj/11.png" alt="">
                </div>
                <div class="caipin-title">
                    <div class="caipin-work">商务餐研发总厨</div>
                    <div class="caipin-name">张文举</div>
                </div>
                <div class="caipin-content">
                    <div class="c">高级公共营养师</div>
                    <div class="c">河南豫菜大师</div>
                    <div class="c">高级技师</div>
                    <div class="c">第二届天娇美食节厨王争霸赛评委</div>
                    <div class="c">名厨名店委员会常务副秘书长</div>
                    <div class="c">第二届青年中西餐烹饪邀请赛青年裁判</div>
                    <div class="c">世界上最大的面气球1.8米保持者</div>
                    <div class="c">国际精厨争霸赛特金奖</div>
                    <div class="c">第25届中国厨师节两项特金奖</div>
                    <div class="c">河南省第四届豫菜品牌大赛特金奖</div>
                </div>
            </div>
            <div class="caipin-box">
                <div class="caipin-img">
                    <img src="../../assets/tdjj/10.png" alt="">
                </div>
                <div class="caipin-title">
                    <div class="caipin-work">团餐研发总厨</div>
                    <div class="caipin-name">郑增辉</div>
                </div>
                <div class="caipin-content">
                    <div class="c">从厨20余年</div>
                    <div class="c">河南团餐名厨</div>
                    <div class="c">高级烹调师</div>
                    <div class="c">翼博餐饮中机六院项目部厨师长</div>
                    <div class="c">擅长菜品创新</div>
                </div>
            </div>
            <div class="caipin-box">
                <div class="caipin-img">
                    <img src="../../assets/tdjj/19.png" alt="">
                </div>
                <div class="caipin-title">
                    <div class="caipin-work">中式面点研发总厨</div>
                    <div class="caipin-name">李昌成</div>
                </div>
                <div class="caipin-content">
                    <div class="c">从厨20余年</div>
                    <div class="c">国家高级公共营养师</div>
                    <div class="c">国家一级面点技师</div>
                    <div class="c">国家职业西点师</div>
                    <div class="c">裕丰杯金奖</div>
                    <div class="c">北京鼎厨大赛特金奖</div>
                    <div class="c">中国烹饪协会会员</div>
                    <div class="c">精通各类中式面点，小吃，西点等等</div>
                </div>
            </div>
        </div>
        <div class="title1">系统研发中心</div>
        <div class="xitong">
            <div class="xitong-box">
                <div class="xitong-img">
                    <img src="../../assets/tdjj/32.png" alt="">
                </div>
                <div class="xitong-right">
                    <div class="xitong-name">张慧芳</div>
                    <div class="xitong-content">
                        <div class="d">系统研发中心前端工程师</div>
                        <div class="d">数据科学与大数据技术学士学位</div>
                        <div class="d">网站建设及维护</div>
                        <div class="d">网页、小程序、APP、公众号界面设计</div>
                    </div>
                </div>
            </div>
            <div class="xitong-box">
                <div class="xitong-img">
                    <img src="../../assets/tdjj/22.png" alt="">
                </div>
                <div class="xitong-right">
                    <div class="xitong-name">王宏坤</div>
                    <div class="xitong-content">
                        <div class="d">系统研发中心全栈工程师</div>
                        <div class="d">大数据技术与应用专业</div>
                        <div class="d">后台数据模型搭建</div>
                        <div class="d">系统版本升级及BUG修复</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="title1">厨房设计部</div>
        <div class="chufang">
            <div class="chufang-box1">
                <div class="chufang-img">
                    <img src="../../assets/tdjj/24.png" alt="">
                </div>
                <div class="chufang-work">产品中心厨房设计金牌顾问</div>
                <div class="chufang-name">陈晓飞</div>
            </div>
            <div class="chufang-box2">
                <div class="chufang-box22">
                    <div class="f-title">设计作品：</div>
                    <div class="f">宝丰县政府职工餐厅</div>
                    <div class="f">仟那酒店厨房及明档自助餐台</div>
                    <div class="f">平顶山市委党校5号楼厨房</div>
                    <div class="f">唐山锦江国际酒店厨房</div>
                    <div class="f">工人路阿勇美食宴会酒店厨房</div>
                    <div class="f">小刘桥阿勇美食宴会酒店</div>
                    <div class="f">鲁山兴源高中一二三楼学生餐厅厨房</div>
                    <div class="f">中牟丽枫宴会酒店厨房</div>
                </div>
                <div class="chufang-box22">
                    <div class="f">郑州机械研究所职工餐厅厨房</div>
                    <div class="f">平顶山第一人民医院餐厅厨房</div>
                    <div class="f">平顶山扶贫办职工餐厅厨房</div>
                    <div class="f">郑州沙口路半闲斋鲜肉涮厨房</div>
                    <div class="f">平顶山城建学院蓝青园餐厅厨房</div>
                    <div class="f">国机集团第六设计研究院职工餐厅厨房</div>
                    <div class="f">商丘莲溪高中一二三楼学生餐厅厨房</div>
                    <div class="f">郑州广电路半闲斋鲜肉涮厨房</div>
                    <div class="f">南阳理工学院餐厅厨房</div>
                </div>
                <div class="chufang-box22">
                    <div class="f">融通医疗天津二七二医院餐厅厨房</div>
                    <div class="f">叶县县委党校餐厅厨房及明档自助餐台</div>
                    <div class="f">西平阿勇美食宴会酒店厨房</div>
                    <div class="f">内蒙古呼伦贝尔贝尔大酒店宴会厨房</div>
                    <div class="f">中国船舶集团第七一三研究所职工餐厅</div>
                    <div class="f">中交城投（郑州）开发建设有限公司厨房</div>
                    <div class="f">商丘驻郑州办事处厨房</div>
                    <div class="f">白象总部三楼职工餐厅厨房</div>
                    <div class="f">......</div>
                </div>
            </div>
        </div>
        <div class="title1">行政管理中心</div>
        <div class="xinzheng">
            <div class="xinzheng-box">
                <div class="xinzheng-img">
                    <img src="../../assets/tdjj/05.png" alt="">
                </div>
                <div class="xinzheng-name">牛玉珂</div>
                <div class="g">行政管理中心负责人</div>
                <div class="g">财务管理专业</div>
                <div class="g">管理学学士学位</div>
            </div>
            <div class="xinzheng-box">
                <div class="xinzheng-img">
                    <img src="../../assets/tdjj/21.png" alt="">
                </div>
                <div class="xinzheng-name">张玉</div>
                <div class="g">综合保障部负责人</div>
                <div class="g">财务管理专业</div>
            </div>
            <div class="xinzheng-box">
                <div class="xinzheng-img">
                    <img src="../../assets/tdjj/25.png" alt="">
                </div>
                <div class="xinzheng-name">肖亚楠</div>
                <div class="g">人力资源部负责人</div>
                <div class="g">人力资源本科学历</div>
                <div class="g">管理学学士学位</div>
            </div>
            <div class="xinzheng-box">
                <div class="xinzheng-img">
                    <img src="../../assets/tdjj/14.png" alt="">
                </div>
                <div class="xinzheng-name">封秋侠</div>
                <div class="g">财务部负责人</div>
                <div class="g">会计专业</div>
            </div>
        </div>
        <div class="title1">项目部</div>
        <div class="xiangmu">
            <div class="xiangmu-box">
                <div class="xiangmu-right">
                    <div class="xiangmu-img">
                        <img src="../../assets/tdjj/26.png" alt="">
                    </div>
                    <div class="xiangmu-work">团餐楼层经理</div>
                    <div class="xiangmu-name">李书红</div>
                </div>
                <div class="xiangmu-left">
                    <div class="xiangmu-content">
                        多年团餐前厅主管服务经验，善于梳理供餐流程，做事风格雷厉风行。曾任某军工企业职工餐厅前厅经理，现任翼博餐饮项目部大堂经理。
                    </div>
                </div>
            </div>
            <div class="xiangmu-box">
                <div class="xiangmu-right">
                    <div class="xiangmu-img">
                        <img src="../../assets/tdjj/20.png" alt="">
                    </div>
                    <div class="xiangmu-work">商务餐楼层经理</div>
                    <div class="xiangmu-name">鲁晓丽</div>
                </div>
                <div class="xiangmu-left">
                    <div class="xiangmu-content">
                        多年社会酒楼管理经验，曾在越秀酒家、皇府鲍鱼、金色港湾、咱家小院任楼层经理，现任翼博餐饮项目部大堂经理。
                    </div>
                </div>
            </div>
            <div class="xiangmu-box">
                <div class="xiangmu-right">
                    <div class="xiangmu-img">
                        <img src="../../assets/tdjj/27.png" alt="">
                    </div>
                    <div class="xiangmu-work">商务餐楼层经理</div>
                    <div class="xiangmu-name">杨雅然</div>
                </div>
                <div class="xiangmu-left">
                    <div class="xiangmu-content">
                        多年会所管理经验，熟悉会所商务接待标准及流程，曾任地产会所负责人，现任翼博餐饮项目部大堂经理。
                    </div>
                </div>
            </div>
        </div>
        <div class="title1">项目部负责人</div>
        <div class="fuzeren">
            <div class="fuzeren-box">
                <div class="fuzeren-img">
                    <img src="../../assets/tdjj/15.png" alt="">
                </div>
                <div class="fuzeren-name">王西杰</div>
                <div class="fuzeren-work">七一三项目经理</div>
            </div>
            <div class="fuzeren-box">
                <div class="fuzeren-img">
                    <img src="../../assets/tdjj/28.png" alt="">
                </div>
                <div class="fuzeren-name">李晓彭</div>
                <div class="fuzeren-work">海为酒店项目经理</div>
            </div>
            <div class="fuzeren-box">
                <div class="fuzeren-img">
                    <img src="../../assets/tdjj/33.png" alt="">
                </div>
                <div class="fuzeren-name">常晓龙</div>
                <div class="fuzeren-work">郑纺机项目经理</div>
            </div>
            <div class="fuzeren-box">
                <div class="fuzeren-img">
                    <img src="../../assets/tdjj/03.png" alt="">
                </div>
                <div class="fuzeren-name">武杨</div>
                <div class="fuzeren-work">中机六院项目经理</div>
            </div>
            <div class="fuzeren-box">
                <div class="fuzeren-img">
                    <img src="../../assets/tdjj/08.png" alt="">
                </div>
                <div class="fuzeren-name">魏长江</div>
                <div class="fuzeren-work">中原工学院项目经理</div>
            </div>
            <div class="fuzeren-box">
                <div class="fuzeren-img">
                    <img src="../../assets/tdjj/31.png" alt="">
                </div>
                <div class="fuzeren-name">张文举</div>
                <div class="fuzeren-work">恒达智控项目经理</div>
            </div>
            <div class="fuzeren-box">
                <div class="fuzeren-img">
                    <img src="../../assets/tdjj/30.png" alt="">
                </div>
                <div class="fuzeren-name">杨豪</div>
                <div class="fuzeren-work">城建学院项目经理</div>
            </div>
            <div class="fuzeren-box">
                <div class="fuzeren-img">
                    <img src="../../assets/tdjj/06.png" alt="">
                </div>
                <div class="fuzeren-name">武姚</div>
                <div class="fuzeren-work">司法局项目经理</div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from "swiper";
import { WOW } from 'wowjs'
export default {
    mounted() {
    //第一种写法，可以设置wow中属性
    this.$nextTick(() => { // 在dom渲染完后,再执行动画
      var wow = new WOW({
        boxClass: 'wow',///动画元件css类（默认为wow）
        animateClass: 'animated',//动画css类（默认为animated） 
        offset: 0,//到元素距离触发动画（当默认为0） 
        mobile: true, //在移动设备上触发动画（默认为true） 
        live: true//对异步加载的内容进行操作（默认为true）
      })
      wow.init()
    }),
    new Swiper(".banner",{
        loop:true, //循环模式选项

        // 如果需要分页器
        pagination:{
            el:".swiper-pagination",
        },
        // 如果需要前进后退按钮
        navigation:{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        // 如果需要滚动条
    //   scrollbar: {
    //     el: ".swiper-scrollbar",
    //   },

      autoplay: {
        autoplay: true, // 自动切换
        disableOnInteraction: false, // 点击之后重新计算
      },
    });
  },
}
</script>

<style scoped>
.banner{
    width: 100%;
    height: 3.5rem;
    overflow: hidden;
}
/* .banner:hover img{
    transform: scale(1.2);
} */
.banner img{
    /* transition: all .4s; */
    width: 100%;
    height: 100%;
    /* display: block;
    object-fit: cover; */
}
.title{
    font-size: .13rem;
    font-weight: 700;
    padding: .15rem 0;
}
.title-hr{
    width: 70%;
    margin: 0 auto;
}

.title1{
    width: 70%;
    height: .2rem;
    line-height: .2rem;
    margin: 0 auto;
    font-size: .09rem;
    font-weight: 700;
}
/* boss */
.main{
    width: 70%;
    background-color: #f6f6f6;
    margin: 0 auto;
}
.main_boss{
    width: 100%;
    height: 1.4rem;
    position: relative ;
}
.boss{
    position: absolute;
    width: 1.3rem;
    height: 1.3rem;
    background-color: #666666;
    border-radius: 50%;
    right: 1.5rem;
    top: .05rem;
    overflow: hidden;
}
.boss-title{
    position: absolute;
    right: 0.5rem;
    top: .3rem;
}
.boss-work{
    font-size: .12rem;
    font-weight: 700;
}
.boss-name{
    font-size: .12rem;
    font-weight: 600;
    margin-top: .02rem;
}
.boss-content{
    position: absolute;
    font-size: .09rem;
    right: 3.2rem;
    font-weight: 550;
    top: .1rem;
}
.a{
    margin-top: .09rem;
}
/* 副总经理 */
.main_boss2{
    width: 100%;
    height: 1.43rem;
    position: relative;
}
.boss-title2{
    position: absolute;
    left: 0.5rem;
    top: .3rem;
}
.boss2{
    position: absolute;
    width: 1.3rem;
    height: 1.3rem;
    background-color: #666666;
    border-radius: 50%;
    left: 1.6rem;
    top: .05rem;
    overflow: hidden;
}
.boss-content2{
    position: absolute;
    font-size: .09rem;
    left: 3.2rem;
    font-weight: 550;
    top: .1rem;
}
.b{
    margin-top: .06rem;
}
/* 菜品研发中心 */
.title1{
    font-size: .1rem;
    font-weight: 700;
    padding: .08rem 0;
    /* color: #666666; */
}
.caipin{
    width: 70%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
}
.caipin-box{
    width: 24%;
    height: 3rem;
    background-color: #f6f6f6;
}
.caipin-img{
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    background: #666666;
    margin: .05rem auto;
    overflow: hidden;
}
.caipin-work{
    font-size: .09rem;
    font-weight: 700;
}
.caipin-name{
    font-size: .09rem;
    font-weight: 700;
}
.c{
    font-size: .08rem;
    /* font-weight: 600; */
    margin-top: .03rem;
}
/* 系统研发中心 */
.xitong{
    width: 70%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
}
.xitong-box{
    width: 49%;
    height: 1.6rem;
    background-color: #f6f6f6;
    display: flex;
}
.xitong-img{
    width: 1.2rem;
    height: 1.2rem;
    border-radius: 50%;
    overflow: hidden;
    background-color: #666;
    margin-top: .2rem;
    margin-left:  .25rem;
}
.xitong-right{
    margin-top: .3rem;
    margin-left: .12rem;
    text-align: left;
}
.xitong-name{
    font-size: .1rem;
    font-weight: 700;
}
.xitong-content{
    margin-top: .09rem;
    font-size: .09rem;
}
.d{
    margin-top: .05rem;
}
/* 厨房设计部 */
.chufang{
    width: 70%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
}
.chufang-box1{
    width: 26%;
    height: 1.9rem;
    background-color:#f6f6f6;
}
.chufang-img{
    width: 1.2rem;
    height: 1.2rem;
    border-radius: 50%;
    overflow: hidden;
    background-color: #666;
    margin-top: .2rem;
    margin-left:  .25rem;
}
.chufang-work{
    font-size: .1rem;
    font-weight: 700;
    margin: .05rem 0;
}
.chufang-name{
    font-size: .1rem;
    font-weight: 700;
}
.chufang-box2{
    width: 74%;
    height: 1.9rem;
    background-color: #f6f6f6;
    display: flex;
    justify-content: space-between;
}
.chufang-box22{
    width: 33%;
    height: 1.8rem;
    margin-bottom: 10px;
}
.f-title{
    font-size: .1rem;
    font-weight: 700;
    margin-top: .07rem;
}
.f{
    font-size: .09rem;
    margin-top: .07rem;
}
/* 行政管理中心 */
.xinzheng{
    width: 70%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
}
.xinzheng-box{
    width: 24%;
    height: 1.75rem;
    background-color: #f6f6f6;
}
.xinzheng-img{
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    background: #666666;
    margin: .05rem auto;
    overflow: hidden;
}
.xinzheng-name{
    font-size: .1rem;
    font-weight: 700;
}
.g{
    font-size: .09rem;
    margin-top: .03rem;
}
/* 项目部 */
.xiangmu{
    width: 70%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
}
.xiangmu-box{
    width: 33%;
    height: 1.6rem;
    background-color: #f6f6f6;
    display: flex;
    justify-content: space-between;
}
.xiangmu-right{
    width: 55%;
}
.xiangmu-left{
    width: 45%;
    
}
.xiangmu-content{
    font-size: .09rem;
    text-align: left;
    padding: .1rem;
    line-height: .15rem;
    text-indent: 2em;
    margin-top: .15rem; 
}
.xiangmu-img{
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    overflow: hidden;
    background-color: #666;
    margin-top: .1rem;
    margin-left: .15rem;
}
.xiangmu-img img{
    height: 1.1rem;
}
.xiangmu-work{
    font-size: .1rem;
    font-weight: 700;
    margin-top: .05rem;
}
.xiangmu-name{
    font-size: .1rem;
    font-weight: 700;
    margin-top: .05rem;
}
/* 项目部负责人 */
.fuzeren{
    width: 70%;
    height: 3rem;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.fuzeren-box{
    width: 24%;
    height: 1.45rem;
    background-color: #f6f6f6;
}
.fuzeren-img{
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    background-color: #666;
    margin: .05rem auto;
    overflow: hidden;
}
.fuzeren-name{
    font-size: .1rem;
    font-weight: 700;
}
.fuzeren-work{
    font-size: .09rem;
    font-weight: 700;
    margin-top: .04rem;
}
</style>